<template>
    <div>
        <b-form-group
            description="Add text that can be picked"
            label="Text"
            :label-cols="3"
            :horizontal="false"
        >
            <b-form-input
                :plain="false"
                v-model="text"
                >
            </b-form-input>
            <b-form-select
                :plain="false"
                :options="constraints.selectables.items"
                :value="selected"
                >
            </b-form-select>
            <div class="form-actions" style="margin: 10px">
                <b-button variant="success" @click="add">Add</b-button>
            </div>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'

export default {
    components: {
        cSwitch
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {
            constraints: this.value,
            text: "",
            selected: ""
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        add() {
            if (this.text != "") {
                this.constraints.selectables.items.push(this.text);
                this.selected = this.text
                this.text = ""
            }   
        }
    }
    
}
</script>